import sessionHelperInstance from "./sessionHelper";
import { Client } from "./_clientService";

const _fetch = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

export async function removeFtuePacks() {
  return _fetch({ method: "delete", path: `/player/pack/removeFtuePacks` });
}

export async function uploadBulkFtuePacks(file: any) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${sessionHelperInstance?.token}`);

    const formData = new FormData();
    formData.append("file", file);

    const req: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow" as RequestRedirect,
    };
    let url = `${import.meta.env.VITE_CMS_API_URL}/player/pack/bulkUpdateFtuePacks`;
    const response = await fetch(url, req);

    return await response.json();
  } catch (error) {
    throw error;
  }
}
